import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "positionDescriptors", "onMouseEnter", "onMouseLeave"];
import { forwardRef, memo } from 'react';
import SpacingWrapper from '../../atoms/SpacingWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PrimaryMessage = /*#__PURE__*/forwardRef(_ref => {
  let {
      children,
      positionDescriptors,
      onMouseEnter,
      onMouseLeave
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return children ? /*#__PURE__*/_jsx(SpacingWrapper, {
    positionDescriptors: positionDescriptors,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "start",
      "data-test-id": props['data-test-id'],
      "data-debug-common-message-mismatch": props['data-debug-common-message-mismatch'],
      children: children
    })
  }) : null;
});
PrimaryMessage.displayName = 'PrimaryMessage';
export default /*#__PURE__*/memo(PrimaryMessage);